import merge from 'lodash/merge';
import omit from 'lodash/omit';
import * as actionTypes from './actionTypes';

const initialState = {
  permissionTree: [],
  entityToObjectIdentityIndex: {},
  objectIdentitiesIsLoading: false,
  entityToObjectIdentityIndexIsLoading: false,
  permissions: {},
  sidsLoadingPermissions: [],
  editingRoleId: null,
  editingSid: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACL_OBJECT_IDENTITIES:
      return {
        ...state,
        objectIdentitiesIsLoading: true,
      };
    case actionTypes.FETCH_ACL_OBJECT_IDENTITIES_SUCCESS:
      return {
        ...state,
        objectIdentitiesIsLoading: false,
      };
    case actionTypes.FETCH_ACL_ENTITY_ID_TO_OID_INDEX:
      return {
        ...state,
        entityToObjectIdentityIndexIsLoading: true,
      };
    case actionTypes.FETCH_ACL_ENTITY_ID_TO_OID_INDEX_SUCCESS:
      return {
        ...state,
        entityToObjectIdentityIndexIsLoading: false,
        entityToObjectIdentityIndex: action.index,
      };
    case actionTypes.SET_PERMISSION_TREE:
      return {
        ...state,
        permissionTree: action.permissionTree,
      };
    case actionTypes.FETCH_PERMISSIONS:
      return {
        ...state,
        sidsLoadingPermissions: [...state.sidsLoadingPermissions, action.sid],
      };
    case actionTypes.FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: merge({}, state.permissions, action.entities.permissions),
        sidsLoadingPermissions: state.sidsLoadingPermissions.filter(id => id !== action.sid),
      };
    case actionTypes.SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.permissions,
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        permissions: omit(state.permissions, action.permission.objectIdentityId),
      };
    case actionTypes.SET_EDITING_ROLE_ID:
      return {
        ...state,
        editingRoleId: parseInt(action.roleId, 10),
      };
    case actionTypes.SET_EDITING_SID:
      return {
        ...state,
        editingSid: action.sid,
      };
    default:
      return state;
  }
};
